import React from 'react'

const ViewPoster = () => (
  <svg viewBox="0 0 22 22" width="22px" height="22px">
    <defs />
    <g className="a" fill="none" stroke="#121212" strokeMiterlimit="10">
      <rect className="c" width="22" height="22" rx="2" stroke="none" />
      <rect
        className="d"
        x="0.5"
        y="0.5"
        width="21"
        height="21"
        rx="1.5"
        fill="none"
        stroke="#121212"
        strokeMiterlimit="10"
      />
    </g>
    <rect className="b" width="10" height="22" rx="2" transform="translate(6)" fill="#121212" />
  </svg>
)

export default ViewPoster
